export default __webpack_public_path__ + "b788b5ea7bebb6d78ab692c6c78d8a69.png";